export const fertSlotRequestsHeaderElements = [
  { label: "Fecha entrega", value: "fechaEntrega", align: "inherit" },
  { label: "Titular cuenta", value: "titularCuenta", align: "inherit" },
  { label: "Cant toneladas", value: "cantidadToneladas", align: "inherit" },
  { label: "Destino", value: "destino", align: "inherit" },
  { label: "Km", value: "kmDistancia", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "inherit" },
];
